const carConfig = (car = {}, action) => {
  switch (action.type) {
    case 'GET_CAR':
      return action.playload;
    default:
      return car;
  }
};
export default carConfig;
